import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { LOAD_TRANSFORMERS } from '../transformers';
import { useEffect } from 'react';
import { $convertFromMarkdownString } from '@lexical/markdown';
import { getSummaryForViewMode } from '../../../Attachments/InlineAttachment';

import { useImpressionEditorContext } from '../../Context';

export const MarkdownChangePlugin = () => {
  const { activeImpression, viewMode } = useImpressionEditorContext();
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.update(() => {
      $convertFromMarkdownString(
        getSummaryForViewMode(activeImpression?.summary ?? '', viewMode),
        LOAD_TRANSFORMERS,
      );
    });
  }, [activeImpression, editor, viewMode]);

  return null;
};
